<template>
  <div class="app_info_top bg--blue-light tx--bege">
    <div class="title">
      {{
        appointment.start_datetime
          ? $moment(new Date(appointment.start_datetime)).format(
              "DD/MM/YYYY יום dddd,  HH:mm  "
            )
          : $moment(new Date(appointment.created_at)).format(
              "DD/MM/YYYY יום dddd,  HH:mm  "
            )
      }}
      <span class="block">{{
        appointment.firstName + " " + appointment.lastName
      }}</span>
    </div>
    <div class="add_new_row flex">
      <div class="add_new_row_col1">סוג התור</div>
      <div class="add_new_row_col2 ft--400">
        {{ appointment.type }}-{{ appointment.insurance }}
      </div>
    </div>
    <div class="add_new_row flex">
      <div class="add_new_row_col1">עלות התור</div>
      <div class="add_new_row_col2 ft--400">₪{{ appointment.fee ?? 0 }}</div>
    </div>
    <div class="add_new_row flex">
      <div class="add_new_row_col1">ת.ז</div>
      <div class="add_new_row_col2 ft--400">{{ appointment.passport }}</div>
    </div>
    <div class="add_new_row flex">
      <div class="add_new_row_col1">תאריך לידה</div>
      <div class="add_new_row_col2 ft--400">
        {{ $moment(appointment.birthDate, "YYYY-MM-DD").format("DD/MM/YYYY") }}
      </div>
    </div>
    <div class="add_new_row flex">
      <div class="add_new_row_col1">
        טלפון <span class="no_mobile">נייד</span>
      </div>
      <div class="add_new_row_col2 ft--400">
        <a class="link" :href="`tel:${appointment.phone}`">{{
          appointment.phone
        }}</a>
      </div>
    </div>
    <div class="add_new_row flex" v-if="appointment.email">
      <div class="add_new_row_col1">
        אימייל
      </div>
      <div class="add_new_row_col2 ft--400">
        <a class="link n-email" :href="`mailto:${appointment.email}`">{{
          appointment.email
        }}</a>
      </div>
    </div>
    <div v-show="appointment.second_phone" class="add_new_row flex no_mobile">
      <div class="add_new_row_col1">טלפון נוסף</div>
      <div class="add_new_row_col2 ft--400">
        <a class="link" :href="`tel:${appointment.second_phone}`">{{
          appointment.second_phone
        }}</a>
      </div>
    </div>
    <div class="add_new_row flex" v-if="appointment.language">
      <div class="add_new_row_col1">שפה מועדפת</div>
      <div class="add_new_row_col2 ft--400">{{ appointment.language }}</div>
    </div>
    <div
      v-if="
        appointment.scheduled_by && getScheduledBy(appointment.scheduled_by)
      "
      class="add_new_row flex"
    >
      <div class="add_new_row_col1">מקור שיבוץ</div>
      <div class="add_new_row_col2 ft--400 flex flex--start has-img">
        <img
          :src="getScheduledBy(appointment.scheduled_by).image"
          :alt="getScheduledBy(appointment.scheduled_by).text"
        />
        {{ getScheduledBy(appointment.scheduled_by).text }}
      </div>
    </div>
    <div v-if="appointment.created_at" class="add_new_row flex">
      <div class="add_new_row_col1">תאריך יצירת התור</div>
      <div class="add_new_row_col2 ft--400">
        {{
          $moment(new Date(appointment.created_at)).format(
            "DD/MM/YYYY,  HH:mm  "
          )
        }}
      </div>
    </div>
    <div v-if="appointment.tafnit_receipt_no" class="add_new_row flex">
      <div class="add_new_row_col1">סטטוס תשלום</div>
      <div class="add_new_row_col2 ft--400 flex flex--start has-img">
        שולם
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSideInfo",
  props: {
    appointment: {
      required: true
    }
  },
  methods: {
    getScheduledBy(type) {
      return this.$store.getters["getAppScheduledBy"](type, true);
    }
  }
};
</script>
